// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const SUGEST_TIPO = {
  Sugestao: 'SUGEST_TIPO1',
  Bug: 'SUGEST_TIPO2',
  NovaFuncionalidade: 'SUGEST_TIPO3',
  Duvida: 'SUGEST_TIPO4',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    SUGEST_TIPO1: 1,
    SUGEST_TIPO2: 2,
    SUGEST_TIPO3: 3,
    SUGEST_TIPO4: 4
  }
}
